import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { Modal } from 'reactstrap'
import { AiOutlineSave } from 'react-icons/ai'

import { revenueType } from '../../../constants'
import { TextArea } from '../../../../../../input'
import { Button } from '../../../../../../buttons'
import { CloseIcon } from '../../../../../../icons'
import { FONTS } from '../../../../../../../constants'

export const RemarkModal = ({
  isEdit,
  isOpen,
  toggle,
  data,
  lobData,
  lobAllocation,
  handleRemark,
}) => {
  const [remark, setRemark] = useState('')
  useEffect(() => {
    setRemark(lobAllocation.remark)
  }, [lobAllocation])

  const onChangeRemark = e => {
    setRemark(e.target.value)
  }

  const resetState = () => {
    setRemark('')
    toggle()
  }

  const lob = lobData.find(l => l._id === lobAllocation.lob_id)

  return (
    <Modal
      isOpen={ isOpen }
      toggle={ resetState }
    >
      <ModalHeader>
        <Header>Remark</Header>
        <CloseIcon onClick={ resetState } />
      </ModalHeader>
      <Body>
        <DetailSection>
          <FirstGroup>
            <Tag color={ revenueType[data.type].color }>{ revenueType[data.type].name }</Tag>
            <Row>
              <RevenueCol>
                <Label>LOB Rev.</Label>
                <FirstGroupText>{lobAllocation ? `฿ ${lobAllocation.lob_revenue}` : '-'}</FirstGroupText>
              </RevenueCol>
              <PercentageCol>
                <Label>LOB %</Label>
                <FirstGroupText>{lobAllocation ? `${lobAllocation.lob_percent}%` : '-'}</FirstGroupText>
              </PercentageCol>
            </Row>
          </FirstGroup>
          <SecondGroup>
            <Row>
              <Column>
                <Label>LOB</Label>
                <SecondGroupText>{ lob ? lob.name : '-' }</SecondGroupText>
              </Column>
              <Column>
                <Label>Start Date - End Date</Label>
                <SecondGroupText>
                  {lobAllocation ? `${moment(lobAllocation.start_date).format('DD/MM/YYYY')} - ${moment(lobAllocation.end_date).format('DD/MM/YYYY')}` : '-'}
                </SecondGroupText>
              </Column>
            </Row>
            <Row>
              <Column>
                <Label>Criteria</Label>
                <SecondGroupText>{ lobAllocation ? lobAllocation.criteria : '-' }</SecondGroupText>
              </Column>
              <Column>
                <Label>Service Contract Price</Label>
                <SecondGroupText>{lobAllocation ? `฿ ${lobAllocation.resource_price}` : '-'}</SecondGroupText>
              </Column>
            </Row>
          </SecondGroup>
        </DetailSection>
        <TextAreaSection>
          <TextArea
            placeholder='Enter Remark'
            disabled={ !isEdit }
            value={ remark }
            onChange={ onChangeRemark }
          />
        </TextAreaSection>
      </Body>
      <Footer>
        { isEdit &&
        <ButtonWrapper>
          <Button
            width='70px'
            height='26px'
            theme='#28a745'
            onClick={ () => {
              handleRemark(remark)
              resetState()
            } }
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
          >
            Save
          </Button>
          <Button
            width='70px'
            height='26px'
            theme='#6c757d'
            onClick={ resetState }
          >
            Cancel
          </Button>
        </ButtonWrapper>
        }
      </Footer>
    </Modal>
  )
}

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 0 16px;
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;
`

const ButtonWrapper = styled.div`
  display: flex;

  div:nth-child(1) {
    margin-right: 12px;
  }
`

const Row = styled.div`
    display: flex;
    justify-content: space-between;

    :nth-last-child(1) {
      margin-top: 10px;
    }
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const RevenueCol = styled(Column)`
    align-items: flex-end;
`

const PercentageCol = styled(Column)`
    align-items: flex-end;
    margin-left: 12px;
`

const FirstGroup = styled.div`
    min-height: 95px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 3;
    background: #F9F9F9;
    border-radius: 4px;
    padding: 8px 10px;
`

const SecondGroup = styled(FirstGroup)`
    flex: 5;
    margin-left: 8px;
`

const Tag = styled.div`
  height: 24px;
  width: 82px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => p.color};
  border-radius: 4px;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #FFFFFF;
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 8px;
  color: #C4C4C4;
`

const FirstGroupText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: 10px;
  color: #1A1A17;
`

const SecondGroupText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #1A1A17;
`

const DetailSection = styled.div`
    display: flex;
`

const TextAreaSection = styled.div`
    margin-top: 8px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/project-detail/remark-modal.js